export { default } from "./Slide"
